import { ErrorPage } from "@components:ErrorPage";
import { NotFound } from "@components:NotFound";
import { PermissionRoute } from "@components:PermissionRoute";
import { ProtectedRoute } from "@components:ProtectedRoute";
import { Root } from "@components:Root";
import { Analytics } from "@pages:app/analytics/Analytics";
import { Audio } from "@pages:app/audio/Audio";
import { Docs } from "@pages:app/talk/docs/Docs";
import { TalkChat } from "@pages:app/talk/TalkChat";
import { TalkSearch } from "@pages:app/talk/TalkSearch";
import { Login } from "@pages:auth/Login";
import { Logout } from "@pages:auth/Logout";
import { Settings } from "@pages:settings/Settings";
import { createBrowserRouter, Navigate, Outlet } from "react-router";

import { Routes } from "@:constants";
import { RBACAction, RBACResource } from "@:rbac";

export const routes = createBrowserRouter([
  {
    path: "/app",
    element: <ProtectedRoute />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Navigate to={Routes.AppChat} />,
      },
      {
        path: "search",
        element: <TalkSearch />,
      },
      {
        path: "chat",
        children: [
          {
            index: true,
            element: <Navigate to="/app/chat/new" replace={true} />,
          },
          {
            path: "/app/chat/:conversationId",
            element: <TalkChat />,
          },
        ],
      },
      { path: "docs", element: <Docs /> },
      {
        path: "analytics",
        element: (
          <PermissionRoute
            action={RBACAction.read}
            resource={RBACResource["analytics"]}
            nextWithPerm={<Analytics />}
            nextNoPerm={<Navigate to={Routes.NotFound} />}
          />
        ),
      },
      { path: "audio", element: <Audio /> },
    ],
  },
  {
    path: Routes.Login,
    element: <Login />,
  },
  {
    path: Routes.Logout,
    element: <Logout />,
  },
  {
    path: Routes.Settings,
    element: <Settings />,
    children: [
      {
        path: Routes.SettingsProfile,
        element: (
          <PermissionRoute
            action={RBACAction.read}
            resource={RBACResource["settings__profile"]}
            nextWithPerm={<Outlet />}
            nextNoPerm={<Navigate to={Routes.NotFound} />}
          />
        ),
      },
      {
        path: Routes.SettingsOrganizations,
        element: (
          <PermissionRoute
            action={RBACAction.read}
            resource={RBACResource["settings__organizations"]}
            nextWithPerm={<Outlet />}
            nextNoPerm={<Navigate to={Routes.NotFound} />}
          />
        ),
      },
      {
        path: Routes.SettingsUsers,
        element: (
          <PermissionRoute
            action={RBACAction.read}
            resource={RBACResource["settings__users"]}
            nextWithPerm={<Outlet />}
            nextNoPerm={<Navigate to={Routes.NotFound} />}
          />
        ),
      },
      {
        path: Routes.SettingsBots,
        element: (
          <PermissionRoute
            action={RBACAction.read}
            resource={RBACResource["settings__bots"]}
            nextWithPerm={<Outlet />}
            nextNoPerm={<Navigate to={Routes.NotFound} />}
          />
        ),
      },
    ],
  },
  {
    path: Routes.NotFound,
    element: <NotFound />,
  },
  {
    path: "/",
    element: <Root />,
  },
  {
    path: "*",
    element: <ErrorPage />,
  },
]);
